import { RemoteImage } from '@cbhq/cds-web/media';
import { HStack } from '@cbhq/cds-web/layout';
import { AvatarSize } from '@cbhq/cds-common';
import { AssetConfig } from '@/onchain/assets';

type Props = {
  assets?: AssetConfig[];
  size?: AvatarSize;
};

// Map size to appropriate negative margin for ~28% overlap
const getOverlapMargin = (size: AvatarSize): -0.5 | -1 | -1.5 | -2 | -3 => {
  switch (size) {
    case 'xxl':
      return -3; // 64px → ~24px overlap
    case 'xl':
      return -2; // 48px → ~16px overlap
    case 'l':
      return -1.5; // 36px → ~12px overlap
    case 'm':
      return -1; // 24px → ~8px overlap
    case 's':
    case 'xs':
      return -0.5; // 16px/12px → ~4px overlap
    default:
      return -2;
  }
};

export function PoolsListTokensMedia({ assets, size = 'l' }: Props) {
  const overlapMargin = getOverlapMargin(size);

  return (
    <HStack>
      {assets?.map((asset, index) => (
        <RemoteImage
          marginEnd={index < assets.length - 1 ? overlapMargin : 0}
          size={size}
          shape="circle"
          key={asset?.displaySymbol}
          source={asset?.imageUrl}
          zIndex={assets.length - index}
        />
      ))}
    </HStack>
  );
}
